module.exports = __webpack_public_path__ + "static/img/p_12.6aee881.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/p_12.jpg
// module id = aUOI
// module chunks = 9